<template>
    <b-modal id="modal-pilih-anggota" size="xl" title="Pilih Anggota" @shown="focusInputSubmit" no-close-on-esc no-close-on-backdrop>
        <div class="form-content-wrapper mb-3">
            <b-form-group label="Search Anggota">
                <div class="d-flex small-search">
                    <b-form-select class="mr-2" v-model="searchBy" id="searchBy" name="searchBy" :options="searchByOption" value-field="id" text-field="name">
                    </b-form-select>
                    <b-form-input class="mr-2" v-model="searchQuery" ref="inputAnggotaSearch" v-on:keyup.enter="searchAnggota" name="gadaiSearchAnggota" placeholder="Pencarian…"></b-form-input>
                    <b-form-input class="mr-2" v-if="showSearchTanggalLahir"
                        v-model="searchByTglLahir" name="filterTanggalLahir"
                        type="date"
                    ></b-form-input>
                    <b-button class="mr-2" variant="pgiBtn" name="anggotaSearchBtn" :disabled="isBusy" @click="searchAnggota">
                        <i class="fa fa-search"></i>
                    </b-button>
                    <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                </div>
                <div v-if="showSearchTanggalLahir == true" class="text-muted small mt-1">
                    Nama anggota dan tanggal lahir <b>WAJIB</b> diisi.
                </div>
                <div v-else class="text-muted small mt-1">
                    Mohon mengisi No. Identitas / Anggota / Member dari angka terdepan.
                </div> 
            </b-form-group>
        </div>
        <b-table bordered hover show-empty :fields="isMobile ? fieldsMobile : fieldsDesktop" :busy="isBusy" :items="items" responsive class="mb-3">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Mengambil data anggota...</strong>
                </div>
            </template>
            <template v-slot:empty>
                Tidak menemukan anggota dengan kriteria pencarian diatas.
            </template>
            <template v-slot:cell(anggota)="row">
                <div>
                    <strong>{{row.item.nama}}</strong><br>
                    No. Anggota: {{row.item.no}}<br>
                    No. Identitas: {{row.item.noIdentitas}}
                </div>
            </template>
            <template v-slot:cell(action)="row">
                <div class="no-wrap">
                    <b-button size="sm" variant="pgiBtn" name="pilihAnggotaBtn" @click="selectAnggota(row.item)">Pilih</b-button>
                </div>
            </template>
        </b-table>
        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
            <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                <b-form-select v-model="show" id="showItems" :options="options" @change="onLimitChange">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled />
                    </template>
                </b-form-select>
                <span class="ml-2">{{ totalViewText }}</span>
            </b-input-group>
            <b-pagination class="mb-0"
                v-model="currentPage"
                align="right"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                @input="onPageChange"
            ></b-pagination>
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" name="cancelPilihAnggotaBtn" @click="cancel()">
                Batalkan
            </b-button>
        </template>            
    </b-modal>
    <!-- <b-alert variant="danger">
        Nasabah ini tidak dapat melakukan gadai (status non-aktif / blacklist). Hubungi HO untuk keterangan lebih lanjut!
    </b-alert> -->
</template>

<script>
export default {
    name: 'modal-pilih-anggota',
    data() {
        return {

            searchQuery: "",
            searchBy: 1,
            searchByTglLahir: null,
            show: 10,

            isMobile: false,

            fieldsDesktop: [
                { key: "no", label: "No. Anggota" },
                { key: "noMember", label: "No. Member" },
                { key: "noIdentitas", label: "No. Identitas" },
                { key: "nama", label: "Nama Anggota" },
                { key: "action", label: "Aksi" },
            ],

            fieldsMobile: [
                { key: "anggota", label: "Anggota" },
                { key: "action", label: "Aksi" },
            ],

            searchByOption: [
                { id: 1, name: "No. Identitas / KTP" },
                { id: 2, name: "Nama & Tgl Lahir Anggota" },
                { id: 3, name: "No. Anggota" },
                { id: 4, name: "No. Member" }
            ],
            showSearchTanggalLahir: false,
            items: [],
            isBusy: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

        }
    },
    watch: {
        "searchBy": function(newValue) {
            this.showSearchTanggalLahir = newValue == 2
        }
    },
    mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    },
    
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {

        getListAnggota() {
            if(this.searchQuery == ""){
                this.$helper.toastErr(this, "Mohon isi pencarian (minimal 3 karakter)")
            }else{
                if(this.searchBy == 2){
                    this.query =  `?query=${this.searchQuery}&searchBy=${this.searchBy}&page=${this.currentPage - 1}&size=${this.show}`
                    if(this.$helper.isNotNullAndNotEmpty(this.searchByTglLahir)) {
                        this.query += "&tanggalLahir="+this.searchByTglLahir
                    }
                }else{
                    this.query =  `?query=${this.searchQuery}&searchBy=${this.searchBy}&page=${this.currentPage - 1}&size=${this.show}`
                }
                this.isBusy = true
                this.$axios.get(`nasabah/findForGadai`+this.query).then(response => {
                    this.items = response.data.data
                    this.updateTotalItem(response.data.total)
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })
            }
        },

        searchAnggota() {
            
            this.currentPage = 1
            this.getListAnggota()

        },

        onReset(){
            this.searchQuery = ""
            this.searchBy = 1
            this.searchByTglLahir = null
            this.items = []
        },

        selectAnggota(item) {
            if (item.isActive == false) {
                return   this.$helper.toastErr(this, " Nasabah ini tidak dapat melakukan gadai (status non-aktif / blacklist). Hubungi HO untuk keterangan lebih lanjut!")
            }
            this.$emit("anggota-selected", item)
        },

        onLimitChange() {

            this.perPage = this.show
            this.onPageChange()

        },

        onPageChange() {
            
            this.getListAnggota()
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage - 1) * this.show + 1
            limit = (this.currentPage - 1) * this.show + this.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"

        },

        updateTotalItem(total) {

            let limit = null
            let prevLimit = null
            this.perPage = this.show
            this.rows = total
            prevLimit = (this.currentPage - 1) * this.show + 1
            limit = (this.currentPage - 1) * this.show + this.show
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"

        },

        focusInputSubmit(){
            this.$refs.inputAnggotaSearch.focus()
        },

        handleResize() {
        this.isMobile = window.innerWidth <= 576;
    },
    },
}
</script>